import { AttachmentQuestionProps } from './types';
import { Stack, Typography, useTheme } from '@mui/material';
import { UploadButton } from 'sharedComponents/Buttons/UploadButton';
import { QuestionLabel } from './QuestionLabel';
import { useState } from 'react';
import { fileNameShortener } from 'utils/util';

export const AttachmentQuestion: React.FC<AttachmentQuestionProps> = ({
  isRequired,
  onChange,
  questionText,
  dataTestId,
  defaultValue,
}) => {
  const parsedFileName = defaultValue
    ? typeof defaultValue === 'string'
      ? fileNameShortener(defaultValue).substring(14)
      : defaultValue.name
    : '';

  const [fileName, setFileName] = useState(parsedFileName);
  const theme = useTheme();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileData = e.target.files?.[0];
    setFileName(fileData.name);

    onChange(e);
  };

  return (
    <>
      <QuestionLabel dataTestId={dataTestId} questionText={questionText} isRequired={isRequired} />
      <Stack
        data-testid={dataTestId}
        direction="row"
        sx={{
          border: `1px solid ${theme.palette.border.main}`,
          borderRadius: theme.spacing(1),
          padding: theme.spacing(2.5),
        }}
      >
        <UploadButton
          buttonText={fileName ? 'Update' : 'Select'}
          dataTestId={`${dataTestId}-upload-button`}
          onChange={handleChange}
          sx={{ width: theme.spacing(3), marginRight: theme.spacing(2.5) }}
        />
        <Stack
          direction="column"
          sx={{ display: 'flex', justifyContent: 'center', overflow: 'auto' }}
        >
          {fileName ? (
            <Typography>{fileName}</Typography>
          ) : (
            <>
              <Typography>Select a file to upload</Typography>
              <Typography>PDF, DOCX, DOC, JPG, PNG</Typography>
            </>
          )}
        </Stack>
      </Stack>
    </>
  );
};
